<template>
  <div @click="listClick">
    <div class="edit_list">
      <span>{{ left }}</span>
      <span>
        <slot name="right"></slot>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["left"],
  methods: {
    listClick() {
      this.$emit("listClick");
    }
  }
};
</script>

<style scoped lang="scss">
.edit_list {
  list-style: none;
  padding: 8px 10px;
  font-size: 14px;
  color: #666;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
